import { render, staticRenderFns } from "./ClientBills.vue?vue&type=template&id=60e2466e&"
import script from "./ClientBills.js?vue&type=script&lang=js&"
export * from "./ClientBills.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports